export default __webpack_public_path__ + "static/media/4010_4016.72207b56.jpg";